<div class="loader-box-container">
  <div class="loader-box">
    <div class="lds-grid">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div class="loader-text" trans>Loading</div>
</div>
